
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 8.5C15.437 8.5 8.5 15.438 8.5 24c0 8.563 6.938 15.5 15.5 15.5 8.563 0 15.5-6.938 15.5-15.5 0-8.563-6.938-15.5-15.5-15.5zm7.6 19.569a.75.75 0 010 1.062L29.125 31.6a.75.75 0 01-1.063 0L24 27.5l-4.069 4.1a.75.75 0 01-1.062 0L16.4 29.125a.75.75 0 010-1.063L20.5 24l-4.1-4.069a.75.75 0 010-1.062l2.475-2.475a.75.75 0 011.063 0L24 20.5l4.069-4.1a.75.75 0 011.062 0l2.475 2.475a.75.75 0 010 1.063L27.5 24l4.1 4.069z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    